export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  views: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: "明星八卦", slug: "mingxing-bagua", icon: "ri-star-line" },
  { name: "社会热点", slug: "shehui-redian", icon: "ri-fire-line" },
  { name: "网红黑料", slug: "wanghong-heiliao", icon: "ri-user-smile-line" },
  { name: "娱乐圈", slug: "yulequan", icon: "ri-movie-line" },
  { name: "情感纠纷", slug: "qinggan-jiufen", icon: "ri-heart-line" },
  { name: "法制曝光", slug: "fazhi-baoguang", icon: "ri-scales-line" },
];

export const articles: Article[] = [
  {
    id: "1",
    title: "某顶流男星深夜密会神秘女子，酒店共度8小时，粉丝集体破防",
    slug: "dingliu-nanxing-shenye-mihui",
    category: "明星八卦",
    categorySlug: "mingxing-bagua",
    excerpt: "据知情人士爆料，某当红顶流男星上周五深夜被拍到与一名神秘女子先后进入某五星级酒店，二人在酒店内共度约8小时后分别离开。该男星工作室目前尚未对此事作出回应，粉丝群体已掀起轩然大波。",
    content: `<p>据知情人士爆料，某当红顶流男星上周五深夜被拍到与一名神秘女子先后进入某五星级酒店，二人在酒店内共度约8小时后分别离开。</p>
<p>据目击者称，当晚11点左右，该男星身穿黑色卫衣、戴着口罩和棒球帽低调现身酒店地下车库。约15分钟后，一名身材窈窕的神秘女子从另一侧电梯进入酒店。两人直至次日早上7点才分别离开。</p>
<p>该男星工作室目前尚未对此事作出回应。但据圈内人士透露，该男星近期正处于新剧宣传期，团队正在紧急公关中。</p>
<p>消息传出后，该男星的粉丝群体迅速分为两派。一部分粉丝表示"造谣可耻，等官方声明"，另一部分则直呼"塌房了塌房了"。相关话题迅速登上热搜榜首，阅读量突破5亿。</p>
<p>值得一提的是，该男星此前一直以"单身暖男"形象示人，曾在多个采访中表示自己"以事业为重，暂不考虑感情问题"。此次事件的曝光无疑对其公众形象造成了巨大冲击。</p>
<p>截至发稿前，该男星及其团队仍未就此事发表任何声明。我们将持续关注事态发展。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20celebrity%20gossip%20paparazzi%20style%20photo%20of%20a%20mysterious%20man%20in%20black%20hoodie%20entering%20luxury%20hotel%20at%20night%20cinematic%20atmosphere%20dim%20lighting%20suspenseful%20mood%20urban%20night%20scene%20blurred%20background&width=800&height=450&seq=article-cover-01&orientation=landscape",
    author: "吃瓜前线",
    publishDate: "2026-08-03",
    views: 128000,
    tags: ["顶流男星", "酒店密会", "深夜约会", "粉丝破防"],
    isHot: true,
    isNew: true,
  },
  {
    id: "2",
    title: "知名女星被曝税务问题，工作室紧急注销引猜测，或面临巨额罚款",
    slug: "zhiming-nvxing-shuiwu-wenti",
    category: "明星八卦",
    categorySlug: "mingxing-bagua",
    excerpt: "某知名女星关联的多家公司近日被曝出现税务异常，其个人工作室已于上月悄然注销。业内人士分析，该女星可能面临数千万甚至上亿元的补税和罚款。",
    content: `<p>某知名女星关联的多家公司近日被曝出现税务异常，其个人工作室已于上月悄然注销。这一消息在圈内引发广泛关注。</p>
<p>据天眼查信息显示，该女星名下关联的7家公司中，有3家被列入经营异常名录，另有2家已注销。其核心工作室的注销时间恰好在上月税务稽查风暴期间，时间点十分微妙。</p>
<p>业内人士分析，该女星可能面临数千万甚至上亿元的补税和罚款。近年来，娱乐圈税务问题频频曝光，从范某到郑某，再到邓某，每一次都引发轩然大波。</p>
<p>该女星此前一直以"正能量""好妈妈"形象深受观众喜爱，若税务问题坐实，其商业价值和公众形象将遭受重创。目前已有多个品牌方暂停与其合作。</p>
<p>有法律人士表示，若查实存在偷逃税款行为，除补缴税款和滞纳金外，还可能面临0.5倍至5倍的罚款。以该女星的收入水平估算，罚款金额可能相当惊人。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20entertainment%20industry%20tax%20scandal%20news%20background%20with%20legal%20documents%20and%20calculator%20on%20dark%20desk%20dramatic%20lighting%20moody%20atmosphere%20financial%20crime%20concept%20blurred%20actress%20silhouette&width=800&height=450&seq=article-cover-02&orientation=landscape",
    author: "税务观察员",
    publishDate: "2026-08-02",
    views: 96000,
    tags: ["女星税务", "工作室注销", "税务稽查", "补税罚款"],
    isHot: true,
    isNew: false,
  },
  {
    id: "3",
    title: "某知名网红直播带货翻车，产品质量遭集体投诉，粉丝怒斥割韭菜",
    slug: "wanghong-zhibo-fanche",
    category: "网红黑料",
    categorySlug: "wanghong-heiliao",
    excerpt: "拥有千万粉丝的某头部网红近日直播带货的一款护肤品被大量消费者投诉使用后出现过敏反应。消费者维权群已聚集超5000人，要求退款赔偿并追究责任。",
    content: `<p>拥有千万粉丝的某头部网红近日直播带货的一款护肤品被大量消费者投诉使用后出现过敏反应。消费者维权群已聚集超5000人，要求退款赔偿并追究责任。</p>
<p>该网红在直播间宣称这款护肤品"温和不刺激""敏感肌也能用""自己用了三年"，吸引了大量粉丝下单购买。然而，不少消费者收到产品使用后出现了不同程度的红肿、瘙痒、刺痛等过敏症状。</p>
<p>更令人愤怒的是，消费者联系客服要求退货退款时，对方以"已拆封使用"为由拒绝退换。该网红本人也未就此事作出任何回应，反而继续正常直播带货。</p>
<p>目前，消费者已经向市场监管局和消协进行了投诉举报。有律师表示，如果产品确实存在质量问题，主播作为推荐者也需要承担相应的法律责任。</p>
<p>这已经不是该网红第一次因带货翻车引发争议了。此前其推荐的减肥产品、美容仪等也多次被质疑虚假宣传。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20livestream%20ecommerce%20controversy%20scene%20with%20skincare%20products%20on%20table%20angry%20consumer%20reviews%20on%20phone%20screen%20dramatic%20lighting%20social%20media%20backlash%20concept%20warm%20indoor%20setting&width=800&height=450&seq=article-cover-03&orientation=landscape",
    author: "消费维权站",
    publishDate: "2026-08-03",
    views: 85000,
    tags: ["网红带货", "产品质量", "消费者维权", "直播翻车"],
    isHot: true,
    isNew: true,
  },
  {
    id: "4",
    title: "某综艺节目录制现场爆发激烈冲突，两位嘉宾大打出手，节目组紧急叫停",
    slug: "zongyi-jiemu-chongtu",
    category: "娱乐圈",
    categorySlug: "yulequan",
    excerpt: "国内某热门综艺节目最新一期录制现场突发意外状况，两位常驻嘉宾因意见不合爆发激烈争吵，随后演变为肢体冲突。节目组被迫中止录制，现场观众被紧急疏散。",
    content: `<p>国内某热门综艺节目最新一期录制现场突发意外状况，两位常驻嘉宾因意见不合爆发激烈争吵，随后演变为肢体冲突。节目组被迫中止录制，现场观众被紧急疏散。</p>
<p>据现场观众透露，冲突起因是游戏环节中关于规则理解的争议。嘉宾A认为嘉宾B在游戏中作弊，两人从最初的言语争执迅速激化，最终演变为互扔道具和推搡。</p>
<p>现场工作人员迅速介入将两人拉开，但冲突已经造成录制中断。节目组随后宣布因"技术原因"暂停录制，并安排现场观众有序离场。</p>
<p>该节目是国内收视率最高的综艺之一，两位涉事嘉宾也都是圈内知名人物。此事件曝光后，网友纷纷猜测二人关系早已不和，此次只是借题发挥。</p>
<p>有业内人士分析，此次冲突可能导致节目组重新考虑嘉宾阵容。若二人无法和解，其中一方或将退出后续录制。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20studio%20recording%20set%20with%20dramatic%20conflict%20atmosphere%20two%20silhouettes%20arguing%20spotlights%20dim%20lighting%20entertainment%20industry%20drama%20behind%20the%20scenes%20tension&width=800&height=450&seq=article-cover-04&orientation=landscape",
    author: "综艺前线",
    publishDate: "2026-08-01",
    views: 112000,
    tags: ["综艺节目", "嘉宾冲突", "录制中止", "娱乐圈"],
    isHot: true,
    isNew: false,
  },
  {
    id: "5",
    title: "某已婚女歌手与经纪人的暧昧关系被曝光，多张亲密合照流出，婚姻亮红灯",
    slug: "yihun-nvgeshou-aiwei",
    category: "明星八卦",
    categorySlug: "mingxing-bagua",
    excerpt: "一位以甜美形象著称的已婚女歌手近日被爆与自己的经纪人存在超出工作关系的亲密往来。多张深夜约会及亲密合照在网络流传，其丈夫据称已搬离共同住所。",
    content: `<p>一位以甜美形象著称的已婚女歌手近日被爆与自己的经纪人存在超出工作关系的亲密往来。多张深夜约会及亲密合照在网络流传。</p>
<p>据爆料，该女歌手与经纪人已合作超过5年。近半年来，两人频繁被拍到在深夜单独相处，举止亲密。有狗仔拍到两人在某高档餐厅包间内共进晚餐，期间举止亲昵，完全不像普通工作关系。</p>
<p>更令人震惊的是，有自称是该女歌手邻居的网友爆料，其丈夫已于上周搬离了二人的共同住所，婚姻似乎已经亮起红灯。该女歌手与丈夫结婚8年，育有两个孩子，一直以恩爱夫妻形象示人。</p>
<p>截至目前，该女歌手及其经纪人均未作出回应。但其社交媒体账号的评论区已被网友攻陷，大量粉丝表示失望和愤怒。</p>
<p>圈内人士透露，该女歌手与经纪人的暧昧关系在圈内其实早已不是秘密，只是没想到会以这种方式被公之于众。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20female%20singer%20scandal%20paparazzi%20style%20photo%20blurred%20restaurant%20scene%20romantic%20dim%20lighting%20secret%20meeting%20atmosphere%20gossip%20magazine%20cover%20aesthetic%20warm%20tones%20intimate%20dinner%20setting&width=800&height=450&seq=article-cover-05&orientation=landscape",
    author: "情感观察室",
    publishDate: "2026-08-02",
    views: 145000,
    tags: ["女歌手", "经纪人", "婚内出轨", "亲密照"],
    isHot: true,
    isNew: false,
  },
  {
    id: "6",
    title: "某知名富二代夜店狂撒百万，与多名网红亲密互动，女友当场摔杯离场",
    slug: "fuerdai-yedian-sajin",
    category: "社会热点",
    categorySlug: "shehui-redian",
    excerpt: "某知名企业家的儿子近日在北京某顶级夜店被拍到挥金如土，一晚上消费超百万，期间与多名女网红亲密互动。其正牌女友闻讯赶到现场后怒摔酒杯愤然离场。",
    content: `<p>某知名企业家的儿子近日在北京某顶级夜店被拍到挥金如土，一晚上消费超百万，期间与多名女网红亲密互动。</p>
<p>据当晚在场的其他客人透露，该富二代包下了夜店最贵的卡座，点了数十瓶顶级香槟和威士忌，还邀请了多位在社交媒体上有一定知名度的女网红前来陪酒。期间他与这些女网红的互动十分亲密，完全不避讳周围人的目光。</p>
<p>有目击者称，该富二代的女友在得知消息后赶到现场，看到眼前场景后当场怒摔酒杯，与富二代发生了激烈争吵后愤然离开。而该富二代并未追出去，反而继续与其他人喝酒玩乐。</p>
<p>该富二代此前就因高调炫富和频繁更换女友而备受争议。其父亲是某知名上市公司的创始人，身家数十亿。这位富二代本人在社交媒体上拥有数百万粉丝，经常晒出豪车名表的奢华生活。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20luxury%20nightclub%20scene%20with%20champagne%20bottles%20and%20neon%20lights%20wealthy%20young%20man%20atmosphere%20dramatic%20social%20elite%20party%20controversy%20blurred%20background%20glamorous%20yet%20chaotic%20mood&width=800&height=450&seq=article-cover-06&orientation=landscape",
    author: "社会观察家",
    publishDate: "2026-08-03",
    views: 76000,
    tags: ["富二代", "夜店", "网红", "炫富"],
    isHot: false,
    isNew: true,
  },
  {
    id: "7",
    title: "某知名导演被多名女演员实名举报性骚扰，圈内震动，警方已介入调查",
    slug: "zhiming-daoyan-xingsaorao",
    category: "法制曝光",
    categorySlug: "fazhi-baoguang",
    excerpt: "一位在影视圈颇具影响力的知名导演近日被至少5名女演员实名举报存在性骚扰行为。举报内容涉及利用试镜和工作机会进行不当行为，时间跨度长达十年。警方已正式立案调查。",
    content: `<p>一位在影视圈颇具影响力的知名导演近日被至少5名女演员实名举报存在性骚扰行为。举报内容涉及利用试镜和工作机会进行不当行为，时间跨度长达十年。</p>
<p>据举报材料显示，该导演多次以"试戏""谈剧本"等名义单独约见女演员，并在过程中实施不当肢体接触和言语骚扰。有受害者表示，该导演曾明确暗示"陪好我就能拿到角色"。</p>
<p>这5名女演员中，有2名是已经有一定知名度的演员，另外3名则是刚入行的新人。她们表示，之所以选择此时站出来举报，是因为看到越来越多的人勇敢发声，不愿再沉默。</p>
<p>消息传出后，圈内一片哗然。多名业内人士表示对此人的行为早有耳闻，但一直缺乏确凿证据和法律途径。警方已正式立案调查，该导演目前处于取保候审状态。</p>
<p>此事件再次引发了社会对娱乐圈权力滥用问题的广泛讨论。不少网友呼吁建立更完善的行业监管机制，保护弱势群体免受侵害。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20film%20industry%20controversy%20concept%20with%20director%20chair%20and%20spotlight%20on%20dark%20stage%20dramatic%20shadows%20justice%20and%20accountability%20theme%20serious%20atmosphere%20cinematic%20mood&width=800&height=450&seq=article-cover-07&orientation=landscape",
    author: "法制观察",
    publishDate: "2026-07-30",
    views: 210000,
    tags: ["导演", "性骚扰", "实名举报", "警方调查"],
    isHot: true,
    isNew: false,
  },
  {
    id: "8",
    title: "某选秀冠军被曝学历造假，人设崩塌，粉丝脱粉回踩，代言品牌集体解约",
    slug: "xuanxiu-guanjun-xueli-zaojia",
    category: "网红黑料",
    categorySlug: "wanghong-heiliao",
    excerpt: "去年某热门选秀节目的冠军选手近日被网友扒出学历造假。其自称的某知名音乐学院本科学历实际仅为旁听经历。事件曝光后，多家代言品牌宣布终止合作。",
    content: `<p>去年某热门选秀节目的冠军选手近日被网友扒出学历造假。其自称的某知名音乐学院本科学历实际仅为旁听经历。</p>
<p>该选手自出道以来一直以"科班出身""音乐学霸"的人设吸引粉丝。在多个采访和节目中，他都声称自己毕业于国内某顶尖音乐学院。然而，有网友通过学信网和校友会等多方渠道核实后发现，该校并没有其注册学籍的记录。</p>
<p>面对质疑，该选手的工作室最初发布声明称"艺人确实在该校学习过"，但随后被网友发现其所谓的"学习"只是短期旁听课程，与正式学历完全是两个概念。</p>
<p>事件持续发酵后，已有5家代言品牌宣布与该选手解除合作关系。其粉丝后援会也出现了大规模脱粉潮，不少老粉纷纷发长文表示"被欺骗太久了"。</p>
<p>有律师指出，如果品牌方因艺人虚假人设遭受损失，可按合同约定追究其违约责任，赔偿金额可能相当可观。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20champion%20scandal%20with%20diploma%20and%20microphone%20on%20dark%20background%20broken%20trophy%20pieces%20dramatic%20lighting%20celebrity%20reputation%20crisis%20concept%20somber%20mood&width=800&height=450&seq=article-cover-08&orientation=landscape",
    author: "打假先锋",
    publishDate: "2026-08-02",
    views: 98000,
    tags: ["选秀冠军", "学历造假", "人设崩塌", "代言解约"],
    isHot: true,
    isNew: false,
  },
  {
    id: "9",
    title: "某知名夫妇被曝已秘密离婚，财产分割涉及数亿，孩子抚养权成焦点",
    slug: "zhiming-fufu-mimi-lihun",
    category: "情感纠纷",
    categorySlug: "qinggan-jiufen",
    excerpt: "演艺圈一对被誉为模范夫妻的知名艺人夫妇近日被曝已于半年前秘密办理离婚手续。由于双方名下共有资产高达数亿元，财产分割和孩子的抚养权问题成为关注焦点。",
    content: `<p>演艺圈一对被誉为模范夫妻的知名艺人夫妇近日被曝已于半年前秘密办理离婚手续。由于双方名下共有资产高达数亿元，财产分割和孩子的抚养权问题成为关注焦点。</p>
<p>据知情人士透露，这对夫妻的感情早在两年前就已出现裂痕，但为了孩子和商业利益一直维持着表面的和谐。两人参与的多个共同商业项目和代言合同使得公开离婚变得异常复杂。</p>
<p>目前，双方正在就财产分割进行谈判。据估算，两人名下共有房产、公司股权、投资等资产总计超过5亿元。此外，两个未成年孩子的抚养权归属也是争议的焦点。</p>
<p>值得关注的是，就在上个月，这对夫妻还一起出席了某品牌活动，在镜头前表现得恩爱如初。这种"表面夫妻"的做法引发了不少网友的反感。</p>
<p>有律师表示，艺人夫妻的离婚案件往往比普通人复杂得多，涉及到的不仅是感情问题，还有庞大的商业利益需要处理。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20celebrity%20divorce%20concept%20with%20two%20wedding%20rings%20separated%20on%20dark%20marble%20surface%20dramatic%20shadow%20lighting%20emotional%20separation%20theme%20luxury%20setting%20golden%20accents%20melancholy%20atmosphere&width=800&height=450&seq=article-cover-09&orientation=landscape",
    author: "婚姻透视镜",
    publishDate: "2026-08-01",
    views: 167000,
    tags: ["明星离婚", "财产分割", "抚养权", "模范夫妻"],
    isHot: true,
    isNew: false,
  },
  {
    id: "10",
    title: "某流量小生剧组耍大牌被曝光，迟到早退还要求特殊待遇，导演怒斥不敬业",
    slug: "liuliang-xiaosheng-shuadapai",
    category: "娱乐圈",
    categorySlug: "yulequan",
    excerpt: "一位近期人气飙升的流量小生被剧组工作人员匿名爆料，称其在拍摄期间多次迟到早退、不配合拍摄，还要求剧组提供超规格待遇。该剧导演在一次拍摄中当众怒斥其不敬业。",
    content: `<p>一位近期人气飙升的流量小生被剧组工作人员匿名爆料，称其在拍摄期间多次迟到早退、不配合拍摄，还要求剧组提供超规格待遇。</p>
<p>据剧组工作人员透露，该流量小生在拍摄期间几乎每天都会迟到1-2小时，全剧组上百号人就干等着他一个人。好不容易来了，又以"状态不好""台词没背熟"为由要求缩减当天的拍摄量。</p>
<p>此外，该演员还提出了诸多过分要求：要求剧组为其配备专属房车、要求每餐必须是特定餐厅的特定菜品、甚至在拍摄现场要求清场，理由是不想让其他演员看到自己没有化妆的样子。</p>
<p>该剧导演在一次拍摄中终于忍无可忍，当众怒斥该演员不敬业，称"你可以不红，但不能不专业"。这段视频被在场工作人员拍下后在网上疯传，引发热议。</p>
<p>业内人士表示，这种现象在流量明星中并不少见。一些年轻艺人走红后就开始飘飘然，忘记了演员的本分。希望此次事件能给行业带来一些反思。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20film%20set%20behind%20the%20scenes%20with%20director%20shouting%20angry%20dramatic%20tension%20empty%20chair%20on%20set%20professional%20conflict%20controversy%20bright%20studio%20lights%20movie%20production%20atmosphere&width=800&height=450&seq=article-cover-10&orientation=landscape",
    author: "剧组观察员",
    publishDate: "2026-07-31",
    views: 134000,
    tags: ["流量小生", "耍大牌", "不敬业", "导演怒斥"],
    isHot: false,
    isNew: false,
  },
  {
    id: "11",
    title: "某知名餐厅后厨卫生状况触目惊心，老鼠乱窜食材过期，网红打卡店翻车",
    slug: "canting-houchu-weisheng",
    category: "社会热点",
    categorySlug: "shehui-redian",
    excerpt: "一家在社交媒体上备受追捧的网红餐厅近日被暗访记者曝光后厨卫生状况极其恶劣。视频中可见老鼠在食材上爬行、使用过期调料、洗碗池洗拖把等触目惊心的画面。",
    content: `<p>一家在社交媒体上备受追捧的网红餐厅近日被暗访记者曝光后厨卫生状况极其恶劣。视频中可见老鼠在食材上爬行、使用过期调料、洗碗池洗拖把等触目惊心的画面。</p>
<p>这家餐厅以其精致的摆盘和INS风格的装修在社交媒体上走红，成为众多年轻人打卡的热门地点。人均消费在300元以上，却被誉为"物超所值的网红餐厅"。</p>
<p>然而，暗访记者在后厨拍到的画面却令人作呕：生熟食混放、蟑螂在案板上爬行、厨师不戴手套徒手抓取食材、过期的调料被继续使用、甚至有人在洗碗池中清洗拖把。</p>
<p>视频曝光后，该餐厅的评分从4.8分骤降至2.1分。市场监管局已经介入调查，餐厅被责令停业整顿。不少曾经光顾过的顾客纷纷表示"要吐了""再也不敢在外面吃饭了"。</p>
<p>食品安全专家表示，网红餐厅普遍存在重营销轻管理的问题，消费者在选择餐厅时应更加关注食品安全而非仅看重颜值和拍照效果。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20restaurant%20kitchen%20hygiene%20scandal%20dirty%20kitchen%20environment%20with%20messy%20countertops%20food%20safety%20violation%20concept%20dim%20lighting%20investigative%20journalism%20atmosphere%20urban%20food%20industry%20dark%20side&width=800&height=450&seq=article-cover-11&orientation=landscape",
    author: "食品安全卫士",
    publishDate: "2026-08-03",
    views: 72000,
    tags: ["餐厅卫生", "后厨曝光", "食品安全", "网红店"],
    isHot: false,
    isNew: true,
  },
  {
    id: "12",
    title: "某女星被前助理爆料私生活混乱，包养多名小鲜肉，月消费超百万",
    slug: "nvxing-qianzhuli-baoliao",
    category: "明星八卦",
    categorySlug: "mingxing-bagua",
    excerpt: "一位以清纯形象著称的女星近日被其前私人助理爆料大量私生活细节。据称该女星私下性格与公众形象截然不同，不仅脾气暴躁，还同时包养多名年轻男性，月均消费超过百万元。",
    content: `<p>一位以清纯形象著称的女星近日被其前私人助理爆料大量私生活细节。据称该女星私下性格与公众形象截然不同，不仅脾气暴躁，还同时包养多名年轻男性。</p>
<p>该前助理在社交媒体上发布了一篇长文，详细描述了其为该女星工作的三年间目睹的种种不堪。据其描述，该女星私下对工作人员极其苛刻，稍有不顺便破口大骂，甚至有过摔东西和打人的行为。</p>
<p>更劲爆的是，该助理爆料称女星同时与至少3名年轻男性保持着不正当关系，每月在这些人身上的花费超过百万。这些男性有模特、有健身教练、也有刚入行的小演员。</p>
<p>该助理表示，选择此时曝光是因为实在无法忍受继续为这样的人工作，而且也不想看到她继续利用虚假人设欺骗粉丝和公众。</p>
<p>截至目前，该女星及其工作室未对此作出回应。但其社交媒体账号在一夜之间掉粉超过50万，多个品牌的合作也被紧急叫停。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20actress%20scandal%20exposed%20concept%20with%20broken%20mirror%20reflecting%20different%20personality%20dark%20dramatic%20lighting%20dual%20identity%20theme%20luxury%20bedroom%20setting%20gossip%20magazine%20atmosphere&width=800&height=450&seq=article-cover-12&orientation=landscape",
    author: "内幕爆料王",
    publishDate: "2026-07-29",
    views: 189000,
    tags: ["女星爆料", "助理曝光", "人设崩塌", "私生活"],
    isHot: true,
    isNew: false,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((a) => a.isHot);
};

export const getNewArticles = (): Article[] => {
  return articles.filter((a) => a.isNew);
};

export const getRelatedArticles = (article: Article, count: number = 4): Article[] => {
  return articles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, count);
};

export const faqData = [
  {
    question: "51吃瓜官网的内容来源是什么？",
    answer: "我们的内容来源于公开媒体报道、网友投稿、知情人士爆料等多方渠道。每一篇爆料文章都经过编辑团队的核实和整理，力求为读者提供真实、及时的娱乐八卦资讯。",
  },
  {
    question: "如何向51吃瓜官网投稿爆料？",
    answer: "您可以通过页面底部的联系方式或联系表单向我们投稿。我们会对每一条爆料进行核实，确认真实性后进行编辑发布。我们承诺严格保护爆料人的隐私和信息安全。",
  },
  {
    question: "爆料内容是否涉及侵犯隐私？",
    answer: "51吃瓜官网严格遵守法律法规，所有发布的内容均基于公开信息或经爆料人授权。我们拒绝发布涉及个人隐私、违反法律法规的内容。如您认为某篇内容侵犯了您的合法权益，请通过联系方式与我们沟通。",
  },
  {
    question: "51吃瓜官网是否收费？",
    answer: "51吃瓜官网是完全免费的娱乐资讯平台。我们不会以任何名义向读者收取费用。如果您遇到任何冒充51吃瓜官网进行收费的情况，请立即向我们举报。",
  },
  {
    question: "为什么叫'51吃瓜'？",
    answer: "'吃瓜'是网络流行语，源自'吃瓜群众'一词，意指旁观、看热闹的状态。51谐音'我要'，合起来就是'我要吃瓜'，表达了我们为大家提供最热、最新娱乐八卦资讯的初心。我们就是大家吃瓜的第一站！",
  },
];